(function() {
    'use strict';

    angular
        .module('am.date-picker', ['ngMaterial', 'ngAnimate']);
        
})();



//////////////////
// WEBPACK FOOTER
// ./~/am-date-picker/dist/am-date-picker.module.js
// module id = 774
// module chunks = 2